/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWERP depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWERP depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWERP depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWERP depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/*!
 * VIEWER v0.0.1
 * 
 * Copyright (C) 2014, Vicomtech-IK4 (http://www.vicomtech.org/)
 * (Spain) all rights reserved.
 *
 * As VIEWER depends on other libraries, the user must adhere to and keep in place any
 * licensing terms of those libraries:
 *
 *   * three.js http://threejs.org/
 *
 * License Agreement for three.js
 * -------------------------------------------------------------------------------------
 * MIT License (http://opensource.org/licenses/MIT)
 */

/**
 * 
 * @namespace
 */
var VIEWER = VIEWER || {};

/**
 * Avatar class
 * @constructor
 */
VIEWER.Avatar = function () {

};

VIEWER.AvatarState = function () {
    var values ={IDLE:0,
        MOVING:1,
        MOVING_TO_TARGET:2
    };
    return values;
}

VIEWER.Avatar.prototype = {

    _avatarName: '',

    _state: 0,

    _animationHandler: {},

    _animations: {},

    _avatarNode: LANA3D.NodeManager.getInstance().createNode("node"),

    _sceneNode: 0,

    /**
    * Gets channel name
    * @returns {string} name
    */
    getName: function () {},

    /**
    * Sets channel name
    * @param {string} name
    */
    setName: function ( name ) {},

    getNode: function() {},

    setSceneNode: function() {},

    getPosition: function() {},

    setPosition: function( pos ) {},

    moveTo: function ( pos ) {},

    movePath: function ( path ) {},

    process: function ( deltaT ) {}
};

/**
 * Scene class
 * @constructor
 */
VIEWER.Scene = function () {

};

VIEWER.Scene.prototype = {

    _name: "",

    _sceneVisuNode: undefined,

    _sceneCollisionNode: undefined,


    /**
    * Gets scene name
    * @returns {string} name
    */
    getName: function () {},

    /**
    * Sets scene name
    * @param {string} name
    */
    setName: function ( name ) {},

    getSceneVisuNode: function() {},

    getSceneCollisionNode: function() {}
};

(function (VIEWER) {
    (function () {

        var _interface = VIEWER.Scene;

        function SceneImpl() {
            _interface.apply ( this, arguments );

            this._useBezier = true;
            this._floorDetectOffset = 30;
            this._name = 'scene';
            this._sceneNode = LANA3D.NodeManager.getInstance().createNode('node');
            this._buildAreaSize = 4000;
        }

        VIEWER.Scene = function () {
            SceneImpl.apply ( this, arguments );
        };

        SceneImpl.prototype = Object.create( VIEWER.Scene.prototype);

        SceneImpl.prototype.getName = function () {
            return this._name;
        };

        SceneImpl.prototype.setName = function ( name ) {
            this._name = name;
        };

        SceneImpl.prototype.setSceneNode = function ( node ) {
            //get bounding box
            var bbox = new THREE.Box3().setFromObject(node.getInternal());
            var maxSize = Math.max (bbox.max.z - bbox.min.z, bbox.max.x - bbox.min.x);
            this.setBuildAreaSize(Math.round(maxSize+(maxSize*0.25)));
            //this.setPFGridResolution(Math.round(maxSize/8));
            this._sceneNode.addChild(node);
        };

        SceneImpl.prototype.getSceneNode = function ( ) {
            return this._sceneNode;
        };

        /*SceneImpl.prototype.getGridCoordFromScenePoint = function ( p ) {
            var x = Math.round((p.x+(this._buildAreaSize*0.5))/this._worldToGrid);
            var y = Math.round((p.z+(this._buildAreaSize*0.5))/this._worldToGrid);
            var gridPoint = { x: x, y: y};
            return gridPoint;
        };*/

        /*SceneImpl.prototype.loadScene = function ( scene ) {
            //clean _sceneNode


            if(scene.editor)
            {
                var editorScene = scene.editor.clone();
                editorScene.getLocalTransform().setRotation(new LANA3D.Vector3(-Math.PI*0.5, 0, 0 ));
                editorScene.setName("editor");
                this._sceneNode.addChild(editorScene);
                var sceneNodes = editorScene.findChildrenByType('mesh', true);
                for(var i=0;i<sceneNodes.length;i++)
                {
                    sceneNodes[i].getInternal().receiveShadow = true;
                }
            }

            if(scene.simulation)
            {
                var simulationScene = scene.simulation.clone();
                simulationScene.getLocalTransform().setRotation(new LANA3D.Vector3(-Math.PI*0.5, 0, 0 ));
                simulationScene.getInternal().visible = false;
                simulationScene.setName("simulation");

                this._sceneNode.addChild(simulationScene);
                var sceneNodes = simulationScene.findChildrenByType('mesh', true);
                for(var i=0;i<sceneNodes.length;i++)
                {
                    sceneNodes[i].getInternal().receiveShadow = true;
                }
            }

            if(scene.collision)
            {
                var collisionScene = scene.collision.clone();
                collisionScene.getLocalTransform().setRotation(new LANA3D.Vector3(-Math.PI*0.5, 0, 0 ));
                collisionScene.getInternal().visible = false;
                collisionScene.setName("collision");
                this._sceneNode.addChild(collisionScene);
                //get bounding box
                var bbox = new THREE.Box3().setFromObject(collisionScene.getInternal());
                var maxSize = Math.max (bbox.max.z - bbox.min.z, bbox.max.x - bbox.min.x);
                this.setBuildAreaSize(Math.round(maxSize+(maxSize*0.25)));
                //this.setPFGridResolution(Math.round(maxSize/16));
            }


        };*/

        SceneImpl.prototype.loadSceneFromFile = function (file) {
          var self = this;
          LANA3D.AssetManager.loadBundle(file, function(result) {
                    var o = result.scene;
                    o.getLocalTransform().getPosition().add( new LANA3D.Vector3(0,0,0) );
                    self._sceneNode.addChild (o);
                });

        }

        SceneImpl.prototype.paintStatus = function (statusModel, node){
            var self = this;
            var n = node;
            LANA3D.AssetManager.loadBundle(statusModel, function(result) {
                    var o = result.scene;
                    o.getLocalTransform().getPosition().add(new LANA3D.Vector3(0,0,0) );
                    o.getLocalTransform().scale.set(0.025,0.025,0.025);
                    n[0].addChild (o);
                });
        }

        SceneImpl.prototype.paintItem = function (node, percentage) {
            var self = this;
            var n = node;
            var file = "models/caja.dae";
            var percentage = percentage;
            var color;
            if (percentage == 0){
                color = {r: 128, g: 255, b: 0}; //verde
            }
            else if (percentage >= 100){
                color = {r: 255, g: 128, b: 0}; //naranja
            }
            else{
                color = {r: 255, g: 255, b: 0}; //amarilla
            }
            // Bloqueada? -> roja

            LANA3D.AssetManager.loadBundle(file, function(result) {
                    
                    var o = result.scene;
                    o.getInternal().children[0].children[0].material.color = color;
                    o.getLocalTransform().getPosition().add(new LANA3D.Vector3(0,0,0) );
                    o.getLocalTransform().scale.set(0.025,0.025,0.025);
                    o.getLocalTransform().setRotation(new LANA3D.Vector3(0, 0 , Math.PI / 2));
                    n[0].addChild (o);
                });
        }

        SceneImpl.prototype.setSceneTransparent = function (node){
            var self = this;
            var n = node;
            var childrenNodes = n.findChildrenByType('mesh', true);

            for(var i=0; i<childrenNodes.length; i++){
                var parent = childrenNodes[i].getParent();
                var parentName = parent.getName();
                if (parentName.indexOf("caja") > -1){
                    childrenNodes[i]._internal.material.opacity = 0.25;
                }

            }
            

        }

        /*SceneImpl.prototype.isWalkable = function ( p ) {
            var gridPoint = this.getGridCoordFromScenePoint(p);
            /*if((gridPoint.x>0 & gridPoint.x<this._PFGridResolution) &
                (gridPoint.y>0 & gridPoint.y<this._PFGridResolution))
            {
                return this._PFGrid.isWalkableAt(gridPoint.x, gridPoint.y);
            }
        }*/

        SceneImpl.prototype.setBuildAreaSize = function ( size ) {
            this._buildAreaSize = size;
            //this._worldToGrid = this._buildAreaSize/this._PFGridResolution;
        };

        VIEWER.Scene.prototype = SceneImpl.prototype;

    })(VIEWER.Impl || (VIEWER.Impl = {}));
}) (VIEWER || (VIEWER = {}));

(function (VIEWER) {
    (function () {

        var _interface = VIEWER.Avatar;

        function AvatarImpl( preloaded ) {
            _interface.apply ( this, arguments );
            this._avatarName = 'avatar';
            this._avatarNode = LANA3D.NodeManager.getInstance().createNode("node");
            this._animationHandler = undefined;
            this._animations = {};
            this._velocity = 100;
            this._rotVelocity = 0.8;
            this._state = VIEWER.AvatarState().IDLE;
            this._moveTarget = new LANA3D.Vector3(0,0,0);
            this._tempMoveTarget = new LANA3D.Vector3(0,0,0);
            this._moveAngleTarget = 0.0;
            this._up_rot = new LANA3D.Quaternion();
            this._up_rot.setFromAxisAngle(new LANA3D.Vector3(1,0,0), -Math.PI*0.5);

            this._path = undefined;
            this._pathID = 0;

            this._raycaster = new THREE.Raycaster();

            var scope = this;

            function handleBundle(result, translate, scale) {
                scope._avatarNode.getLocalTransform().getScale().multiplyScalar(scale);
                scope._avatarNode.getLocalTransform().getPosition().add(translate);
                scope._avatarNode.getLocalTransform().setQuaternion(scope._up_rot);

                var children = result.scene.children;
                for(var i=0;i<children.length;i++)
                {
                    scope._avatarNode.addChild(children[i].clone());
                }

                var meshNodes = scope._avatarNode.findChildrenByType('mesh.skinned', true);
                for(var i=0;i<meshNodes.length;i++)
                {
                    meshNodes[i].getInternal().castShadow = true;
                }

                var skeleton = [];
                var bundleAnimations = [];
                for (var i = 0; i < result.assets.length; i++) {
                    if(result.assets[i].type=="skeleton")
                        skeleton.push(result.assets[i])

                    if(result.assets[i].type=="animationclip")
                        bundleAnimations.push(result.assets[i])
                }

                var bundleHandlers = LANA3D.AnimationManager.createDefaultHandlers(scope._avatarNode, bundleAnimations);
                for (var i = 0; i < bundleHandlers.length; i++) {
                    scope._animationHandler = bundleHandlers[i];
                    var states = bundleHandlers[i].getAnimationStates();
                    for (var j = 0; j < states.length; j++) {
                        scope._animations[states[j]._name] = states[j];
                        //states[j].setEnabled(true);
                        //states[j].setSpeed(0.5);
                        states[j].setWeight(0);
                    }
                }

                if(skeleton.length >=1 && scope._animationHandler){
                    scope._animationHandler.setSkeleton(skeleton[0]);
                    scope._animationHandler._states["idle"].setWeight(1.0);
                    scope._animationHandler._states["idle"].setEnabled(true);
                }
            }

            if(preloaded==undefined){
                LANA3D.AssetManager.loadBundle("models/avatars/gennaro.json", function(avatar) {
                    handleBundle(avatar, new LANA3D.Vector3(0,0,0), 1.0);

                });
            }else{
                this._avatarName = preloaded.name;
                handleBundle(preloaded.node, new LANA3D.Vector3(0,0,0), 1.0);
            }
        }

        VIEWER.Avatar = function () {
            AvatarImpl.apply ( this, arguments );
        };

        AvatarImpl.prototype = Object.create( VIEWER.Avatar.prototype);

        AvatarImpl.prototype.getName = function () {
            return this._avatarName;
        };

        AvatarImpl.prototype.setName = function ( name ) {
            this._avatarName = name;
        };

        AvatarImpl.prototype.getState = function () {
            return this._state;
        };

        AvatarImpl.prototype.getPath = function () {
            return this._path;
        };

        AvatarImpl.prototype.getNode = function () {
            return this._avatarNode;
        };

        AvatarImpl.prototype.setSceneCtr = function ( scene ) {
            this._sceneCtr = scene;
        };

        AvatarImpl.prototype.getPosition = function () {
            return this._avatarNode.getInternal().position;
        };

        AvatarImpl.prototype.setPosition = function ( pos ) {
            this._avatarNode.getLocalTransform().setPosition(pos);
        };

        AvatarImpl.prototype.setVelocity = function ( vel ) {
            this._velocity = vel;
        };

        AvatarImpl.prototype.moveTo = function ( pos ) {
            if(this._state == VIEWER.AvatarState().IDLE)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
            }
            this._moveTarget.set(pos.x,pos.y,pos.z);
            this._tempMoveTarget.set(pos.x,pos.y,pos.z);
            this._state = VIEWER.AvatarState().MOVING;
            var avatarPos = this._avatarNode.getLocalTransform().getPosition();
            var target_vec =  new LANA3D.Vector2( this._moveTarget.x - avatarPos.x, this._moveTarget.z - avatarPos.z );
             this._moveAngleTarget = target_vec.normalize();
        };

        AvatarImpl.prototype.movePath = function ( path ) {
            this._pathID = 0;
            this._path = path;
            if(this._state == VIEWER.AvatarState().IDLE)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
            }
            this._moveTarget.set(path[this._pathID].x,0.0,path[this._pathID].y);
            this._state = VIEWER.AvatarState().MOVING_TO_TARGET;
            var avatarPos = this._avatarNode.getLocalTransform().getPosition();
            var target_vec =  new LANA3D.Vector2( path[this._pathID].x - avatarPos.x,
                path[this._pathID].y - avatarPos.z );
            this._moveAngleTarget = target_vec.normalize();
        };

        AvatarImpl.prototype.moveForward = function ( mov) {
            this._moving_forward = mov;

            if(this._state == VIEWER.AvatarState().IDLE && mov)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
                this._state = VIEWER.AvatarState().MOVING;
            }
        }

        AvatarImpl.prototype.moveBackward = function ( mov ) {
            this._moving_backward = mov;

            if(this._state == VIEWER.AvatarState().IDLE && mov)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
                this._state = VIEWER.AvatarState().MOVING;
            }
        }

        AvatarImpl.prototype.rotateRight = function ( mov ) {
            this._moving_rotate_right = mov;

            if(this._state == VIEWER.AvatarState().IDLE && mov)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
                this._state = VIEWER.AvatarState().MOVING;
            }
        }

        AvatarImpl.prototype.rotateLeft = function ( mov ) {
            this._moving_rotate_left = mov;

            if(this._state == VIEWER.AvatarState().IDLE && mov)
            {
                this._animationHandler.crossfade( 'idle', 'walk', 1.0 );
                this._state = VIEWER.AvatarState().MOVING;
            }
        }

        AvatarImpl.prototype.stop = function ( ) {

            if(this._state == VIEWER.AvatarState().MOVING)
            {
                this._animationHandler.crossfade( 'walk', 'idle', 1.0 );
                this._state = VIEWER.AvatarState().IDLE;
            }

            this._moving_forward = false;
            this._moving_backward = false;
            this._moving_rotate_left = false;
            this._moving_rotate_right = false;
        }

        AvatarImpl.prototype.process = function ( deltaT )
        {
            var vel = this._velocity * deltaT;
            var rotVel = this._rotVelocity * deltaT;
            var self = this;

            function dirVector(obj1, obj2){
                return new LANA3D.Vector3(obj1.x-obj2.x, obj1.y-obj2.y, obj1.z-obj2.z);
            }
            function distance(obj1, obj2) {
                var dirVec = dirVector(obj1, obj2);
                return Math.sqrt((dirVec.x*dirVec.x) + (dirVec.y*dirVec.y) + (dirVec.z*dirVec.z));
            }

            if(this._state == VIEWER.AvatarState().MOVING)
            {
                function checkMovement(translate){
                    var trasMatrix = new LANA3D.Matrix4x4();
                    trasMatrix.makeTranslation(translate.x, translate.y, translate.z);
                    var mat = new LANA3D.Matrix4x4();
                    mat.copy(self._avatarNode.getLocalTransform().getMatrix());
                    mat.multiply(trasMatrix);
                    return self._sceneCtr.isWalkable(mat.getPosition());
                }
                if(this._moving_forward)
                {
                    var translate = new LANA3D.Vector3(0, -1*vel, 0);
                    if(checkMovement(translate)){
                        this._avatarNode.getLocalTransform().translate(translate);
                    }
                }
                if(this._moving_backward)
                {
                    var translate = new LANA3D.Vector3(0, 1*vel, 0);
                    if(checkMovement(translate)){
                        this._avatarNode.getLocalTransform().translate(translate);
                    }
                }
                if(this._moving_rotate_left)
                {
                    this._avatarNode.getLocalTransform().rotate(new LANA3D.Vector3(0, 0, 1 ), rotVel);
                }
                if(this._moving_rotate_right)
                {
                    this._avatarNode.getLocalTransform().rotate(new LANA3D.Vector3(0, 0, 1 ), -rotVel);
                }

            }else if(this._state == VIEWER.AvatarState().MOVING_TO_TARGET)
            {
                var transform = this._avatarNode.getLocalTransform();
                var avatarPos = transform.getPosition();
                var rot = transform.getRotation();
                var target_quat = new LANA3D.Quaternion();
                target_quat.setFromAxisAngle(new LANA3D.Vector3(0,1,0),
                    Math.atan2(this._moveAngleTarget.x, this._moveAngleTarget.y));
                target_quat.multiply(this._up_rot);
                var dist = distance(this._moveTarget, avatarPos);

                var finishMoving = false;
                if(this._path)
                {
                    var nextDist = dist;
                    if(this._pathID<this._path.length-1)
                    {
                        //find neares path point
                        var pathID = this._pathID;
                        while(nextDist<=dist && pathID<this._path.length-1)
                        {
                            dist = nextDist;
                            pathID++;
                            nextDist = distance(new LANA3D.Vector3(this._path[pathID].x,0.0,this._path[pathID].y), avatarPos);
                        }
                        if(pathID>this._pathID+1){
                            this._pathID = pathID
                            if(pathID<this._path.length-1)
                                this._pathID++;//truco para que no haya saltos con pocos fps
                        }
                        var target_vec =  new LANA3D.Vector2( this._path[this._pathID].x - avatarPos.x,
                            this._path[this._pathID].y - avatarPos.z );
                        this._moveAngleTarget = target_vec.normalize();
                        this._moveTarget.set(this._path[this._pathID].x,0.0,this._path[this._pathID].y);
                        if(dist<5.0 && this._pathID<this._path.length-1)
                        {
                            this._pathID++;
                        }
                    }
                    else
                    {
                        if(dist<5.0)
                        {
                            this._pathID = 0;
                            this._path = undefined;
                            finishMoving = true;
                        }
                    }
                }else{
                    if(dist<5.0)
                    {
                        finishMoving = true;
                    }
                }

                if(finishMoving){
                    this._animationHandler.crossfade( 'walk', 'idle', 1.0 );
                    this._state = VIEWER.AvatarState().IDLE;
                }else{
                    var dir = dirVector(this._moveTarget, avatarPos);
                    dir.normalize();
                    this._avatarNode.getLocalTransform().getQuaternion().slerp(target_quat, rotVel*5);
                    this._avatarNode.translate(new LANA3D.Vector3(dir.x*vel, dir.y*vel, dir.z*vel));
                }


            }
        };

        VIEWER.Avatar.prototype = AvatarImpl.prototype;

    })(VIEWER.Impl || (VIEWER.Impl = {}));
}) (VIEWER || (VIEWER = {}));

